var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix"},[_c('a-upload',{attrs:{"action":_vm.uploadImgUrl,"show-upload-list":false,"headers":_vm.headers},on:{"change":_vm.handleChange}},[_c('div',{staticClass:"video-main"},[_c('a-button',{attrs:{"loading":_vm.loading}},[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" "+_vm._s(_vm.$t('上传视频'))+" ")],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }